/* @flow */

import React, { Component } from 'react';
import { Grid, Divider, Button, Form } from 'semantic-ui-react';
import OctoResourceCard from 'shared/components/OctoResourceCard';
import * as ResourceServices from 'catalog/services/resources';

type Props = {
  block: EditorialBlock,
  onSerialize?: (block: EditorialBlock) => void,
};

const DEFAULT_ASPECT = 16 / 9;
const DEFAULT_MODE = 'crop';

class Edit extends Component {
  props: Props;

  serializeBlock(block) {
    this.props.onSerialize({
      mode: DEFAULT_MODE,
      ...block,
    });
  }

  changeMode = mode => () =>
    this.serializeBlock({
      ...this.props.block,
      mode,
    });

  renderContent() {
    const { block } = this.props;

    const imageUpdated = image =>
      this.serializeBlock({
        ...block,
        image,
      });

    // const imageProcessed = url =>
    //   this.serializeBlock({
    //     ...block,
    //     image: {
    //       ...block.image,
    //       raw: url,
    //     },
    //   });

    const imageDeleted = image =>
      this.serializeBlock({
        ...block,
        image: undefined,
      });

    if (!block.mode || block.mode === 'crop') {
      const strategy =
        block._cropImageStrategy ||
        ResourceServices.createServerDrivenStrategy({
          aspect: DEFAULT_ASPECT,
        });

      return (
        <OctoResourceCard
          strategy={strategy}
          resource={block.image}
          onUpdated={imageUpdated}
          // onProcessed={imageProcessed}
          onDeleted={imageDeleted}
        />
      );
    } else {
      return (
        <div>
          <OctoResourceCard
            resource={block.image}
            onUpdated={imageUpdated}
            onDeleted={imageDeleted}
          />
          <Grid columns={2} textAlign="center">
            <Grid.Column>
              <Button.Group>
                <Button
                  onClick={this.changeMode('standard')}
                  active={block.mode === 'standard'}
                >
                  Standard
                </Button>
                <Button
                  onClick={this.changeMode('limitless')}
                  active={block.mode === 'limitless'}
                >
                  Sans limite
                </Button>
              </Button.Group>
            </Grid.Column>
          </Grid>
        </div>
      );
    }
  }

  render() {
    const { block } = this.props;

    const buttonsDisabled = !!block.image;

    const captionChanged = event =>
      this.serializeBlock({
        ...block,
        caption: event.target.value,
      });

    return (
      <div>
        <Grid columns={2} textAlign="center">
          <Grid.Column>
            <Button.Group>
              <Button
                onClick={this.changeMode('standard')}
                disabled={buttonsDisabled}
                active={block.mode && block.mode !== 'crop'}
              >
                Image entière
              </Button>
              <Button
                onClick={this.changeMode('crop')}
                disabled={buttonsDisabled}
                active={!block.mode || block.mode === 'crop'}
              >
                Image recoupée
              </Button>
            </Button.Group>
          </Grid.Column>
        </Grid>
        <Divider />
        <Form>
          <Form.Field>
            <label>Légende</label>
            <input
              placeholder="Légende"
              value={block.caption || ''}
              onChange={captionChanged}
            />
          </Form.Field>
        </Form>
        <Divider />
        {this.renderContent()}
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/image/Edit.js